import { Exclude, Expose, Type } from 'class-transformer';

import { ApiProperty } from '@nestjs/swagger';
import { JobMasterSheetInterface } from '../interfaces/job-master-sheet.interface';
import { BuilderInterface } from 'src/modules/builder/interfaces/builder.interface';
import { JobPhaseInterface } from 'src/modules/job-phase/interfaces/job-phase.interface';
import { JobInterface } from 'src/modules/job/interfaces/job.interface';
import { RegionInterface } from 'src/modules/region/interfaces/region.interface';
import { PhaseInterface } from 'src/modules/phase/interfaces/phase.interface';

@Exclude()
export class JobMasterSheetDto implements JobMasterSheetInterface {
  //
  // Job fields
  //
  @ApiProperty({
    title: 'Job ID (synonym for React Admin only)',
  })
  @Expose()
  id!: string;

  @ApiProperty({
    title: 'Job ID',
  })
  @Expose()
  jobId!: string;

  @ApiProperty({
    title: 'PO ID',
  })
  @Expose()
  poId!: string;

  @ApiProperty({
    title: 'User ID',
  })
  @Expose()
  userId!: string;

  @ApiProperty({
    title: 'Job Lot',
  })
  @Expose()
  jobLot!: string;

  @ApiProperty({
    title: 'Job Block',
  })
  @Expose()
  jobBlock!: string;

  @ApiProperty({
    title: 'Job current Job Phase ID',
  })
  @Expose()
  jobPhaseId!: string;

  @ApiProperty({
    title: 'Job current Job Phase ID',
  })
  @Expose()
  currentPhaseType!: PhaseInterface['phaseType'];

  @ApiProperty({
    type: 'number',
    title: 'Job Days',
    description:
      'Days between hang phase start and spray phase approval or current date, excluding Sundays.',
  })
  @Expose()
  jobDaysCount!: number;

  //
  // Phase fields
  //

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Phase ID',
  })
  @Expose()
  currentPhaseId!: string;

  @ApiProperty({
    type: 'string',
    title: 'Phase Name',
  })
  @Expose()
  currentPhaseName!: string;

  //
  // Subdivision fields
  //

  @ApiProperty({
    title: 'Subdivision ID',
  })
  @Expose()
  subdivisionId!: string;

  @ApiProperty({
    title: 'Subdivision Name',
  })
  @Expose()
  subdivisionName!: string;

  @ApiProperty({
    title: 'Supervisor User ID',
  })
  @Expose()
  supervisorUserIds!: string;

  @ApiProperty({
    title: 'Supervisor Full Name',
  })
  @Expose()
  supervisorFullNames!: string;

  //
  // Region fields
  //

  @ApiProperty({
    title: 'Region ID',
  })
  @Expose()
  regionId = '';

  @ApiProperty({
    title: 'Region Name',
  })
  @Expose()
  regionName!: string;

  @ApiProperty({
    type: 'date-time',
    title: 'Created At',
  })
  @Expose()
  @Type(() => Date)
  createdAt!: Date | null;

  //
  // Builder fields
  //

  @ApiProperty({
    title: 'Builder Id',
  })
  @Expose()
  builderId!: string;

  @ApiProperty({
    title: 'Builder Name',
  })
  @Expose()
  builderName!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Building Id',
  })
  @Expose()
  buildingId!: string | null;

  @ApiProperty({
    type: 'string',
    title: 'Building Name',
  })
  @Expose()
  buildingNumber!: string | null;

  @ApiProperty({
    type: 'string',
    title: 'Address',
  })
  @Expose()
  address1!: string | null;

  @ApiProperty({
    type: 'string',
    title: 'Address 2',
  })
  @Expose()
  address2!: string | null | undefined;

  @ApiProperty({
    type: 'string',
    title: 'Zip',
  })
  @Expose()
  zip!: string | null;

  @ApiProperty({
    type: 'string',
    title: 'City',
  })
  @Expose()
  city!: string | null;

  @ApiProperty({
    type: 'string',
    title: 'State',
  })
  @Expose()
  state!: string | null;

  //
  // Board purchase fields
  //

  @ApiProperty({
    title: 'Total Payable Boards',
  })
  @Expose()
  payableBoardsTotal!: number | null;

  @ApiProperty({
    title: 'Total Supervisor Count',
  })
  @Expose()
  payableBoardsReceiptTotal!: number | null;

  //
  // Garage Phase fields
  //

  @ApiProperty({
    title: 'Garage Contractor Id',
  })
  @Expose()
  garagePhaseContractorId!: string | null;

  @ApiProperty({
    title: 'Garage Contractor Name',
  })
  @Expose()
  garagePhaseContractorName!: string | null;

  @ApiProperty({
    type: 'date-time',
    title: 'Garage Start Date',
  })
  @Expose()
  @Type(() => Date)
  garagePhaseDateStart!: Date | null;

  @ApiProperty({
    type: 'string',
    title: 'Garage Suggested Contractor Name',
  })
  @Expose()
  garagePhaseSuggestedContractorName!: string;

  //
  // Hanger Phase fields
  //

  @ApiProperty({
    title: 'Hanger Contractor Id',
  })
  @Expose()
  hangPhaseContractorId!: string | null;

  @ApiProperty({
    title: 'Hanger Contractor Name',
  })
  @Expose()
  hangPhaseContractorName!: string | null;

  @ApiProperty({
    type: 'date-time',
    title: 'Hanger Start Date',
  })
  @Expose()
  @Type(() => Date)
  hangPhaseDateStart!: Date | null;

  @ApiProperty({
    title: 'Hanger Suggested Contractor Name',
  })
  @Expose()
  hangPhaseSuggestedContractorName!: string | null;

  //
  // Finisher Phase fields
  //

  @ApiProperty({
    title: 'Finisher Contractor Id',
  })
  @Expose()
  finishPhaseContractorId!: string | null;

  @ApiProperty({
    title: 'Finisher Contractor Name',
  })
  @Expose()
  finishPhaseContractorName!: string | null;

  @ApiProperty({
    title: 'Finisher Suggested Contractor Name',
  })
  @Expose()
  finishPhaseSuggestedContractorName!: string | null;

  @ApiProperty({
    type: 'date-time',
    title: 'Finisher Start Date',
  })
  @Expose()
  @Type(() => Date)
  finishPhaseDateStart!: Date | null;

  //
  // Sprayer Phase fields
  //

  @ApiProperty({
    title: 'Sprayer Contractor Id',
  })
  @Expose()
  sprayPhaseContractorId!: string | null;

  @ApiProperty({
    title: 'Sprayer Contractor Name',
  })
  @Expose()
  sprayPhaseContractorName!: string | null;

  @ApiProperty({
    title: 'Spray Suggested Contractor Name',
  })
  @Expose()
  sprayPhaseSuggestedContractorName!: string | null;

  @ApiProperty({
    type: 'date-time',
    title: 'Sprayer Start Date',
  })
  @Expose()
  @Type(() => Date)
  sprayPhaseDateStart!: Date | null;

  //
  // Custom fields
  //

  @ApiProperty({
    title: 'Current phase contractor id',
    nullable: true,
  })
  @Expose()
  currentPhaseContractorId!: string;

  @ApiProperty({
    type: 'string',
    title: 'Suggested Contractor Name',
  })
  @Expose()
  currentPhaseSuggestedContractorName!: string;

  @ApiProperty({
    title: 'Current phase approved status',
  })
  @Expose()
  currentPhaseApproved!: boolean;

  @ApiProperty({
    title: 'Phase request is overdue',
  })
  @Expose()
  currentPhaseRequestIsOnTime!: boolean;

  @ApiProperty({
    title: 'Phase approval is overdue',
  })
  @Expose()
  currentPhaseApprovalIsOnTime!: boolean;

  @ApiProperty({
    title: 'Phase is overdue',
  })
  @Expose()
  currentPhaseIsOnTime!: boolean;

  @ApiProperty({
    type: 'date-time',
    title: 'Current Phase Date Requested',
  })
  @Expose()
  @Type(() => Date)
  currentPhaseDateRequested!: Date | null;

  @ApiProperty({
    type: 'number',
    title: 'Current Phase Days',
    description:
      'Days in the current phase, excluding Sundays, based on approval date or current date.',
  })
  @Expose()
  currentPhaseDaysCount!: number;

  @ApiProperty({
    title: 'Active Job',
  })
  @Expose()
  activeJob!: boolean;

  @ApiProperty({
    title: 'Pre-Rock',
    description: 'Indicates if the job includes a pre-rock option.',
    type: 'boolean',
  })
  @Expose()
  preRock!: boolean;

  //
  // Prime Phase fields
  //
  @ApiProperty({ title: 'Prime Contractor Id' })
  @Expose()
  primePhaseContractorId!: string | null;

  @ApiProperty({ title: 'Prime Contractor Name' })
  @Expose()
  primePhaseContractorName!: string | null;

  @ApiProperty({ title: 'Prime Suggested Contractor Name' })
  @Expose()
  primePhaseSuggestedContractorName!: string | null;

  @ApiProperty({ type: 'date-time', title: 'Prime Start Date' })
  @Expose()
  @Type(() => Date)
  primePhaseDateStart!: Date | null;

  @ApiProperty({
    type: 'number',
    title: 'totalSquareFootage',
    description: 'totalSquareFootage.',
  })
  @Expose()
  totalSquareFootage!: number;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'phaseStructureType',
  })
  @Expose()
  phaseStructureType!: string;

  @ApiProperty({
    type: 'number',
    title: 'Current Phase Days',
    description:
      'Days in the current phase, excluding Sundays, based on approval date or current date.',
  })
  @Expose()
  primePhaseDateStartCount!: number | null;

  @ApiProperty({
    type: 'number',
    title: 'Current Phase Days',
    description:
      'Days in the current phase, excluding Sundays, based on approval date or current date.',
  })
  @Expose()
  finishPhaseDateStartCount!: number | null;

  @ApiProperty({
    type: 'number',
    title: 'Current Phase Days',
    description:
      'Days in the current phase, excluding Sundays, based on approval date or current date.',
  })
  @Expose()
  sprayPhaseDateStartCount!: number | null;

  @ApiProperty({
    title: 'Job Phase Id Prime',
  })
  @Expose()
  primeJobPhaseId!: string | null;

  @ApiProperty({
    title: 'Job Phase Id Finish',
  })
  @Expose()
  finishJobPhaseId!: string | null;

  @ApiProperty({
    title: 'Job Phase Id Spray',
  })
  @Expose()
  sprayJobPhaseId!: string | null;

  @ApiProperty({
    type: 'date-time',
    title: 'PoSignedAt',
  })
  @Expose()
  @Type(() => Date)
  poSignedAt!: Date;

  @ApiProperty({
    title: 'currentPhaseContractorName',
  })
  @Expose()
  currentPhaseContractorName!: string | null;
}
